import Box from '@components/base/Box'
import React from 'react'
import { BaseInputProps } from './BaseInputProps'
import { validate } from './Validations'

export interface RadioFieldInputProps extends BaseInputProps {
  options: string[]
  itemClassName?: string
}

/**
 * Primary UI component for radio inputs.
 */
export const RadioFieldInput = ({
  label,
  value = '',
  onChange,
  className,
  hint,
  validations,
  required,
  options,
  testid,
  itemClassName = '',
}: RadioFieldInputProps) => {
  const errorMessage = validate(value, validations)
  const inputName = label?.toString().toLowerCase().trim().replaceAll(' ', '_')

  return (
    <fieldset className={['flex flex-col gap-3', className].join(' ')}>
      <legend
        className={`text-sm font-medium text-[#153e3e] transition-all ${
          errorMessage ? 'text-red-500' : ''
        }`}
      >
        <span
          className={
            required
              ? "after:content-['*'] after:ml-1 after:text-red-500"
              : ''
          }
        >
          {label}
        </span>
        {hint ? <span className="ml-2 text-xs font-normal">{hint}</span> : null}
      </legend>
      <Box className="flex flex-col gap-3 sm:flex-row sm:flex-wrap">
        {options?.map((option, i) => (
          <label
            key={option}
            className={`${itemClassName} flex cursor-pointer items-center gap-2 text-sm font-medium text-[#153e3e]`}
          >
            <input
              data-testid={testid ? `${testid}-${i}` : null}
              type="radio"
              className="peer sr-only"
              name={inputName}
              value={option}
              checked={value === option}
              onChange={(e) => {
                onChange && onChange(e.target.value, false)
              }}
            />
            <span
              aria-hidden="true"
              className="h-[18px] w-[18px] shrink-0 rounded-full border-2 border-[#153e3e] bg-transparent transition-all peer-checked:border-[5px] peer-focus-visible:ring-2 peer-focus-visible:ring-[#153e3e]/30"
            />
            <span className="min-w-0">{option}</span>
          </label>
        ))}
      </Box>

      <Box
        ignoreTheme
        className={`transition-all ${
          errorMessage ? 'opacity-100' : 'opacity-0'
        } text-red-500 text-sm font-bold`}
      >
        {errorMessage ?? '-'}
      </Box>
    </fieldset>
  )
}
